import React, { useState, useEffect } from "react";

import { useRef } from "react";
import { useHttp } from "../hooks/useHttp";
import { useQuery } from "@tanstack/react-query";
import { CButton, CFormCheck, CTable, CTableBody, CTableDataCell, CTableHead, CTableHeaderCell, CTableRow } from "@coreui/react";

import LoadingCenter from "../components/LoadingCenter";
import PopupTransferDirOutdated from "../components/PopupTransferDirOutdated";

const OverdueCustomersDir = () => {
  const [trigger, setTrigger] = useState(false);
  const [customersRepo, updateCustomersRepo] = useState([]);
  const [customersRepoSelected, updateCustomersRepoSelected] = useState([]);

  const page = useRef(1);
  const request = useHttp();

  const { data: customers, isLoading, isFetching } = useQuery(["bidder-outdated"], () => request({ url: `/users/bidder/outdated?page=${page.current}`, method: "GET" }), { refetchOnWindowFocus: false });

  useEffect(() => {
    updateCustomersRepo(customers?.data?.map(customer => {
      return {
        checked: false,
        ...customer
      }
    }));
  }, [isFetching, customers]);

  const onChangeCheck = (event, customer) => {
    let { checked } = event.target;

    updateCustomersRepo(customersRepo.map(oldCustomer => {
      if (customer.id === oldCustomer.id) {
        oldCustomer.checked = checked;
      }

      return oldCustomer;
    }));
  }

  const onChangeAll = event => {
    let { checked } = event.target;

    updateCustomersRepo(customersRepo.map(customer => {
      customer.checked = checked;

      return customer;
    }));
  }

  const onSubmit = (event) => {
    event.preventDefault();

    let selectedCustomers =
      customersRepo?.filter(customer => customer.checked == true);

    console.log("The form is submitted!", selectedCustomers);
  }

  useEffect(() => {
    let selectedCustomers =
      customersRepo?.filter(customer => customer.checked == true);

    updateCustomersRepoSelected(selectedCustomers);
  }, [customersRepo]);

  return (
    <div className="d-flex flex-column">
      <PopupTransferDirOutdated customers={customersRepoSelected} trigger={trigger} setTrigger={setTrigger} />

      <div className="header border-bottom border-top-right-radius-8">
        <span>Clientes arrematantes vencidos</span>
      </div>

      <div className="dashboard__container-chart">
        <div className="x-p-20 y-p-20">
          {isLoading && <LoadingCenter />}

          <form onSubmit={onSubmit}>
            {!isLoading && <CTable hover>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell scope="col" width={34}>

                  </CTableHeaderCell>
                  <CTableHeaderCell scope="col">

                  </CTableHeaderCell>
                  <CTableHeaderCell scope="col">

                  </CTableHeaderCell>
                </CTableRow>
                <CTableRow>
                  <CTableHeaderCell scope="col" width={34}>
                    <span className="text-color">
                      {/* <CFormCheck name="customers" value={customer.id} checked={customer.checked} onChange={event => onChangeCheck(event, customer)} /> */}
                      <CFormCheck name="customers" onChange={e => onChangeAll(e)} />
                    </span>
                  </CTableHeaderCell>
                  <CTableHeaderCell scope="col">
                    <span className="text-color">Id</span>
                  </CTableHeaderCell>
                  <CTableHeaderCell scope="col">
                    <span className="text-color">Nome</span>
                  </CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                {customersRepo?.map(item => {
                  return (
                    <CTableRow key={item.id}>
                      <CTableDataCell align="top" width={34}>
                        <CFormCheck name="customers" value={item.id} checked={item.checked} onChange={event => onChangeCheck(event, item)} />
                      </CTableDataCell>
                      <CTableDataCell align="top">
                        <span className="text-color">
                          {item.id}
                        </span>
                      </CTableDataCell>
                      <CTableDataCell align="top">
                        <span className="text-color">
                          {item.name}
                        </span>
                      </CTableDataCell>
                    </CTableRow>
                  );
                })}
              </CTableBody>
            </CTable>
            }
            {customersRepoSelected && (
              <CButton color="secondary" variant="ghost" onClick={() => setTrigger(!trigger)}>
                Transferir selecionados
              </CButton>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default OverdueCustomersDir;